import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const VerifyEmailOTP = () => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const { userId, updateEmailVerified } = useAuth();
  const navigate = useNavigate();
  // const location = useLocation(); // Removed - not used

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!otp || otp.length !== 6) {
      setError('Please enter a valid 6-digit code');
      setLoading(false);
      return;
    }

    try {
      await authAPI.verifyEmailOTP(userId, otp);
      updateEmailVerified(true);
      
      // Redirect to discover - it will check profile completion and show modal if needed
      navigate('/discover', { replace: true, state: { justVerified: true } });
    } catch (err) {
      console.error('Verification error:', err);
      setError(err.response?.data?.error || 'Invalid or expired code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setResending(true);
    setError('');
    
    try {
      await authAPI.sendEmailOTP(userId);
      setError(''); // Clear any previous errors
      // Show success message briefly
      const successMsg = '✅ New code sent! Check your inbox and spam folder.';
      setError(successMsg);
      setTimeout(() => {
        if (error === successMsg) setError('');
      }, 4000);
    } catch (err) {
      console.error('Failed to resend OTP:', err);
      setError('Failed to send code. Please try again.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ 
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
            fontSize: '32px',
            color: 'white'
          }}>✉</div>
          <h2>Verify Your Email</h2>
          <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '14px', marginTop: '8px' }}>
            We sent a 6-digit code to your email
          </p>
          
          {/* Spam folder reminder */}
          <div style={{
            marginTop: '16px',
            padding: '12px 16px',
            background: 'rgba(251, 191, 36, 0.1)',
            border: '1px solid rgba(251, 191, 36, 0.3)',
            borderRadius: '12px',
            textAlign: 'left'
          }}>
            <p style={{ 
              color: '#fbbf24', 
              fontSize: '13px', 
              margin: 0,
              fontWeight: '600'
            }}>
              Can't find the email?
            </p>
            <p style={{ 
              color: 'rgba(251, 191, 36, 0.8)', 
              fontSize: '12px', 
              margin: '4px 0 0 0',
              lineHeight: '1.4'
            }}>
              Check your spam/junk folder. Mark it as "Not Spam" to receive future emails in your inbox.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Verification Code</label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="Enter 6-digit code"
              maxLength="6"
              required
              disabled={loading}
              style={{ 
                textAlign: 'center', 
                fontSize: '24px', 
                letterSpacing: '8px',
                fontWeight: '700'
              }}
            />
          </div>

          {error && (
            <div 
              className={error.includes('sent') ? 'success' : 'error'} 
              style={{ 
                padding: '12px', 
                backgroundColor: error.includes('sent') ? '#d1fae5' : '#fee2e2', 
                color: error.includes('sent') ? '#065f46' : '#dc2626',
                borderRadius: '8px',
                marginBottom: '16px',
                fontSize: '14px'
              }}
            >
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className="btn btn-primary" 
            style={{ width: '100%', marginBottom: '16px' }}
            disabled={loading || otp.length !== 6}
          >
            {loading ? 'Verifying...' : 'Verify Email'}
          </button>

          <div style={{ textAlign: 'center' }}>
            <p style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '14px', marginBottom: '12px' }}>
              Didn't receive the code?
            </p>
            <button
              type="button"
              onClick={handleResendOTP}
              disabled={resending}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#3b82f6',
                fontSize: '14px',
                fontWeight: '600',
                cursor: resending ? 'not-allowed' : 'pointer',
                textDecoration: 'underline',
                opacity: resending ? 0.5 : 1
              }}
            >
              {resending ? 'Sending...' : 'Resend Code'}
            </button>
          </div>
        </form>

        <div style={{ 
          marginTop: '24px', 
          paddingTop: '24px', 
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          textAlign: 'center'
        }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailOTP;
